<template>
    <div class="house-info">
        <div v-if="goodLive || featureList.length" class="tags">
            <div v-if="goodLive" class="good-to-live">
                <img src="@/assets/img/shareHouse/good_to_live.svg" alt="">
                好住認證
            </div>
            <div class="feature" v-for="(item, index) in featureList" :key="index">
                {{item.itemName}}
            </div>
        </div>
        <h1 class="title">
            房源介紹
            <span class="is-rented" v-if="houseStatus == 3 && isPublish">此房源出租中，可先預訂</span>
        </h1>
        <div class="info">
            <div class="list">
                <span class="title">房屋格局</span>
                <span class="content">{{housePattern}}</span>
            </div>
            <div class="list">
                <span class="title w70">位於樓層</span>
                <span class="content">{{floor}}樓</span>
            </div>
            <div class="list">
                <span class="title w70">繳租時間</span>
                <span class="content">{{payRentDay}}</span>
            </div>
        </div>
        <div class="info">
            <div class="list">
                <span class="title">最快起租日</span>
                <span class="content">{{getFormatDate(moveInDate)}}</span>
            </div>
            <div class="list">
                <span class="title w70" >最短租期</span>
                <span class="content">{{shortestPeriod}}個月</span>
            </div>
            <div class="list">
                <span class="title">房源編號</span>
                <span class="content">{{houseId}}</span>
            </div>
        </div>
        <div v-if="nearStation" class="near-station">
            {{nearStation}}
        </div>
        <div v-if="goodHouse" class="good-house">
            <span class="certification good">
                <img src="@/assets/img/shareHouse/good_house_mb.svg" alt="">
                <span>飛豬好房</span>
            </span>
            <span class="certification">
                <img src="@/assets/img/shareHouse/tick_red.svg" alt="">
                飛豬親自認證
            </span>
            <span class="certification">
                <img src="@/assets/img/shareHouse/tick_red.svg" alt="">
                租房品質保證
            </span>
        </div>
        <!-- <div v-if="isClose" class="description" >
            <div :class="{hide: description.length > 300 || countBreakSign > 3}" v-html="description.split('\n').join('<br>')"></div>
            <span v-if="isClose && description.length > 300 || countBreakSign > 3 && $route.query.mode != 'contract'" @click="isClose=false" class="more">
                詳細內容
                <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
            </span>
        </div>
        <div v-else class="description">
            <span v-if="!isClose && $route.query.mode != 'contract'" @click="isClose=true" class="close">
                收起
                <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
            </span>
            <div v-html="description.split('\n').join('<br>')"></div>
            <span v-if="!isClose && $route.query.mode != 'contract'" @click="isClose=true" class="close close-down">
                收起
                <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
            </span>
        </div> -->
        <div class="description">
            <div v-html="description.split('\n').join('<br>')"></div>
        </div>
        
        
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return{
            isClose: true
        }
    },
    mounted () {
        if(this.$route.query.mode == 'contract'){
            this.isClose = false
        }
    },
    methods: {
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'/'+formatDate[5]+'/'+formatDate[6];
        },
        wordingLimit: function (str) {
            return str.substring(1,140)+'...'
        },
    },
    computed: {
        countBreakSign: function () {
            let description = this.description
            return description.split('\n').length-1
        },
        ...mapGetters({
            description: 'GET_SHARE_HOUSE_DESCRIPTION',
            houseId: 'GET_SHARE_HOUSE_ID',
            shortestPeriod: 'GET_SHARE_HOUSE_SHOTEST_PERIOD',
            floor: 'GET_SHARE_HOUSE_FLOOR',
            moveInDate: 'GET_SHARE_HOUSE_MOVE_IN_DATE',
            housePattern: 'GET_SHARE_HOUSE_PATTERN',
            houseStatus: 'GET_SHARE_HOUSE_STATUS',
            isPublish: 'GET_SHARE_HOUSE_IS_PUBLISH',
            payRentDay: 'GET_SHARE_HOUSE_PAY_RENT_DAY',
            goodHouse: 'GET_SHARE_HOUSE_GOOD_HOUSE',
            goodLive: 'GET_SHARE_HOUSE_GOOD_LIVE',
            featureList: 'GET_SHARE_HOUSE_FEATURE_LIST',
            nearStation: 'GET_SHARE_NEAR_STATION',
        })
    },
}
</script>
<style lang="scss" scoped>
    .house-info{
        position: relative;
        width: 100%;
        .tags{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 15px;
            font-size: 15px;
            >div{
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                margin-right: 8px;
                height: 28px;
                padding: 0 8px;
                margin-bottom: 8px;
            }
            .good-to-live{
                background-color: #d7effe;
                color: #01bdfe;
                >img{
                    margin-right: 5px;
                }
            }
            .feature{
                background-color: rgba($color: #9a9999, $alpha: 0.1);
                color: #9a9999;
            }
        }
        h1.title{
            position: relative;
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
            display: flex;
            align-items: center;
            .is-rented{
                margin-left: 24px;
                font-size: 16px;
                font-weight: 500;
                color: #fb6b63;
            }
            .is-rented:before{
                content: '';
                position: absolute;
                width: 4px;
                height: 4px;
                background-color: #fb6b63;
                border-radius: 50%;
                top: 15px;
                left: 123px;
            }
        }
        .info{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .list{
                display: flex;
                font-size: 16px;
                margin-bottom: 16px;
                .title.w70{
                    width: 70px;
                }
                .title{
                    width: 80px;
                    color: #909090;
                    margin-right: 10px;
                    display: inline-flex;
                }
                .content{
                    display: flex;
                }
            }
            .list:nth-child(1){
                width: 234px;
            }
            .list:nth-child(2){
                width: 150px;
            }
            .list:nth-child(3){
                width: 250px;
            }
        }
        .near-station{
            position: relative;
            color: #ff9275;
            font-size: 18px;
            font-weight: 400;
            margin-top: 10px;
            margin-left: 10px;
            &::before{
                content: '';
                position: absolute;
                height: 15px;
                width: 2px;
                background: #ff9275;
                left: -10px;
                top: 4px;
            }
        }
        .good-house{
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #f6f8f9;
            width: 482px;
            border-radius: 6px;
            margin: 24px 0;
            height: 59px;
            padding: 0 25px;
            box-sizing: border-box;
            .certification{
                position: relative;
                display: flex;
                align-items: center;
                color: #666666;
                width: 127px;
                font-size: 18px;
                >img{
                    margin-right: 7px;
                }
                &.good{
                    >img{
                        position: absolute;
                        // width: 115%;
                        left: -20px;
                    }
                    >span{
                        position: absolute;
                        color: #303030;
                        right: 15px;
                    }
                }
            }
        }
        .close{
            position: absolute;
            right: 0;
            top: -40px;
            font-size: 14px;
            display: flex;
            align-items: center;
            color: #2db2ff;
            font-weight: 400;
            cursor: pointer;
            img{
                margin-left: 5px;
                transform: rotate(180deg);
            }
        }
        .close-down{
            top: unset;
            bottom: -23px;
        }
        .description{
            position: relative;
            margin-top: 24px;
            font-size: 16px;
            line-height: 1.5;
            word-break: break-word;
            white-space: break-spaces;
            display: flex;
            flex-direction: column;
            .hide{
                height: 100px;
                overflow: hidden;
                margin-bottom: 5px;
                
            }
            .more{
                position: relative;
                color: #2db2ff;
                cursor: pointer;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 8px;
                height: 20px;
                img{
                    margin-left: 2px;
                }
            }
            // .close{
            //     position: absolute;
            //     right: 0px;
            //     bottom: 3px;
            //     font-size: 14px;
            //     display: flex;
            //     align-items: center;
            //     color: #2db2ff;
            //     font-weight: 400;
            //     cursor: pointer;
            //     img{
            //         margin-left: 5px;
            //         transform: rotate(180deg);
            //     }
            // }
        }
    }
    @media (max-width: 992px) {
        .house-info{
            .tags{
                display: none;
            }
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
            .info{
                display: none;
            }
            .near-station{
                display: none;
            }
            .good-house{
                display: none;
            }
            >.close{
                top: 4px;
            }
            .description{
                margin-top: 0px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/houseInfo.vue